import { useQuery } from '@tanstack/react-query';
import { getIntegratedProperty } from '../service';

function useIntegratedProperty(agencyPortfolioPropertyId: string | number, {
    isEnabled = true,
}: {
    isEnabled?: boolean;
} = {}) {
    const query = useQuery({
        queryKey: ['non-managed-property', agencyPortfolioPropertyId],
        queryFn: () => getIntegratedProperty(agencyPortfolioPropertyId),
        enabled: isEnabled,
    });

    return query;
}

export { useIntegratedProperty };
